import { Bugfender } from '@bugfender/sdk';
import { useContext, useEffect, useState } from 'react';

import { NotificationContext } from '@client/context/NotificationContext';

import type { TError } from '@common/types';

export const useError = () => {
  const [error, setError] = useState<TError>(null);
  const { notificationApi } = useContext(NotificationContext);

  useEffect(() => {
    if (error) {
      Bugfender.error(error);

      notificationApi?.error({
        title: error.data.message,
        description:
          (error.data as any)?.response?.data?.message || error.description,
        placement: 'topRight',
        duration: null,
      });
    }
  }, [error, notificationApi]);

  return { setError };
};
